import {sizePx} from '@/theme/helpers/size';
import typography from '@/theme/typography';
import styled from 'styled-components';
import FollowButton from '@/molecules/Buttons/Follow/FollowButton';
import breakpoints from '@/theme/constants/breakpoints';

export const StyledArtistName = styled.p`
  ${typography.Title}
  margin-bottom: ${sizePx(10)};
`;

export const StyledFollowButton = styled(FollowButton)`
  margin-top: ${sizePx(10)};

  @media only screen and ${breakpoints.device.l} {
    display: none;
  }
`;
